<template>
    <ul class="alphabet-scroll">
        <li class="letter"
            v-for="(letter, i) in alphabet"
            @click="context.$scrollTo(i)"
            :style="{marginBottom: margin(letter, i)}">
            {{ letter.letter }}
        </li>
    </ul>
</template>

<script>
  export default {
    name: 'AlphabetScroll',
    props: {
      alphabet: {
        type: Array,
        required: true
      },
      scrollPos: {
        type: Number,
        required: true
      },
      context: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        total: 0
      }
    },
    watch: {
      alphabet: function (val) {
        let total = 0
        val.map((d) => {
          total += d.count
        })
        this.total = total
      }
    },
    methods: {
      margin (letter, i) {
        if (i === 0 || this.alphabet.length - 1 === i) {
          return 'none'
        } else {
          return `calc((100vh - 55px) * ${(letter.count / this.total) * 0.68})` // а хз почему 0.68 - но работает стабильно
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AlbhabetScroll.vue?b788b776